export const outerLinks = {
  스쿨플랫_학생앱_사용_가이드_링크:
    'https://hill-structure-ae3.notion.site/1c3f64225de481a5b55ecb82e74fc646',
}
